import notificationList from "./list.vue";
import notificationEdit from "./edit.vue";
let a = Object.assign({ notificationList, notificationEdit })
export default a;
